import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SplitPane from 'react-split-pane';

const SplitPanel = ({
  children = null,
  right = null,
  minSize = 300,
  defaultSize = '50%',
  onChangeSize,
}) => {
  const [dragging, setDragging] = useState(false);

  let primary = 'second';

  let className = 'my-split-pane';
  if (!right) {
    className += ' inactive';
    primary = undefined;
  }

  return (
    <SplitPane
      split="vertical"
      primary={primary}
      className={className}
      minSize={minSize}
      defaultSize={defaultSize}
      onDragStarted={() => setDragging(true)}
      onDragFinished={() => setDragging(false)}
      onChange={onChangeSize}
    >
      <div style={{ pointerEvents: dragging ? 'none' : 'auto', display: 'contents' }}>
        {children}
      </div>
      <div style={{ pointerEvents: dragging ? 'none' : 'auto', display: 'contents' }}>{right}</div>
    </SplitPane>
  );
};

SplitPanel.propTypes = {
  right: PropTypes.element,
};

export default SplitPanel;
